module.exports = __webpack_public_path__ + "img/gs.ec71511d.png";